import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { createAppConfig } from '@ui/shared/feature-config';
import { PreventionListMapDataService } from './app/services/prevention-list-map-data.service';
import { SearchFilterConfigService } from './app/services/filter/search-filter-config.service';
import { CategorySelectFilterConfigService } from './app/services/filter/category-select-filter-config.service';
import { AgeGroupSelectFilterConfigService } from './app/services/filter/age-group-select-filter-config.service';
import { PreventionListMeasureMapDataService } from './app/services/data/prevention-list-measure-map-data.service';
import type { PreventionListItemModel } from './app/definitions/prevention-list-item.model';
import type { PreventionListFilter } from './app/types/prevention-list-filters';

bootstrapApplication(AppComponent, createAppConfig<PreventionListItemModel, PreventionListFilter>({
    mapDataStateService: PreventionListMapDataService,
    filterItems: [
        SearchFilterConfigService,
        CategorySelectFilterConfigService,
        AgeGroupSelectFilterConfigService,
    ],
    dataEndpoints: [
        PreventionListMeasureMapDataService,
    ],
})).catch((err: unknown) => console.error(err));
